/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Col_LabelInputs */

const vi_shop_col_label = /** @type {(inputs: Shop_Col_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nhãn cho khách`)
};

/**

* @param {Shop_Col_LabelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_col_label = /** @type {((inputs?: Shop_Col_LabelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Col_LabelInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_col_label(inputs)
});